/**
 * Setup Game Info
 *
 */

gameData = {};
game = (function () {
  var _gameName = "Redbeard's Rum Runners";
  var _gameVersionMajor = '1';
  var _gameVersionMinor = '0';
  var _gameVersionBugFix = '40';
  let _gameReleaseDate = '21/07/2025';
  let _currentSplash = 1;
  let _numberOfSplashScreens = 2;

  ///////////////////////
  // Developer options //
  ///////////////////////

  // Reflex.developerModeData.highlightTranslatedText = true;

  Reflex.enableDeveloperMode();

  ///////////////////////
  ///////////////////////

  gameData.gameVersionMajor = _gameVersionMajor;
  gameData.gameVersionMinor = _gameVersionMinor;
  gameData.gameVersionBugFix = _gameVersionBugFix;
  gameData.gameReleaseDate = _gameReleaseDate;
  gameData.currentSplash = _currentSplash;
  gameData.numberOfSplashScreens = _numberOfSplashScreens;
  gameData.lastForce = undefined;
  gameData.recoverLuckyBetOn = false;
  gameData.stakes = [];
  gameData.defaultStakeIndex = undefined;

  function createVersion() {
    var versionString = _gameName + ' v' + _gameVersionMajor + '.' + _gameVersionMinor + '.' + _gameVersionBugFix;
    console.log(versionString);
  }

  function initialise(gameConfigTask) {
    // Store game configuration
    gameData.gameConfig = gameConfigTask.data;

    createVersion();
    //slotMachine.selectReelMode("standard");

    for (i = 0; i < gameConfigTask.data.slotConfig.coinSizes.length; i++) {
      gameData.stakes.push(
        gameConfigTask.data.slotConfig.coinSizes[i] * gameConfigTask.data.slotConfig.defaultNumLines
      );
    }

    gameData.currentStakeIndex = gameConfigTask.data.slotConfig.coinSizes.indexOf(
      gameConfigTask.data.slotConfig.defaultAmountPerLine
    );

    gameData.defaultStakeIndex = gameData.currentStakeIndex;

    gameData.expandIndices = {
      top: 0,
      bottom: 8,
    };
    gameData.contractIndices = {
      top: 5,
      bottom: 8,
    };
  }

  function onModal(data) {}

  function onReelInteraction(reel, row) {
    console.log('Clicked on Reel' + reel + ', Symbol ' + row);

    // Animate the symbol at that position
    var animation = {
      type: 'Symbol',
      slotMachine: undefined,
      sound: 'symbol_Ten',
      data: [
        {
          multiplier: 1,
          reel: reel,
          row: row,
          symbolIndex: gameData.reels[reel].getSymbol(row),
          value: 0,
        },
      ],
    };
    tikiRunnerSymbolAnimator.playAnimation(animation, function () {});
  }

  function dimAllSymbols(dim, duration = 0.3) {
    for (var i = 0; i < reelManager.reels.length; i++) {
      reelManager.reels[i].dimAllSymbols(dim, duration);
    }
  }

  function showSplash(splashNumber) {
    // const splashToShow = resourceManager.get("infoContainer", splashNumber);
    const cont1 = resourceManager.get('infoContainer1');
    const cont2 = resourceManager.get('infoContainer2');

    switch (splashNumber) {
      case 1:
        cont1.visible = true;
        cont2.visible = false;
        break;
      case 2:
        cont1.visible = false;
        cont2.visible = true;
        cont2.alpha = 0;

        const duration = 0.25;
        const offset = 200;
        const pos1 = cont1.x - offset;
        const pos2 = cont2.x;

        cont2.x += offset;

        gsap
          .timeline()
          .to(cont1, {
            duration,
            x: pos1,
            alpha: 0,
          })
          .to(
            cont2,
            {
              duration,
              x: pos2,
              alpha: 1,
            },
            '<+=0.15'
          );
        break;
    }
  }

  function onCloseTutorial() {
    resourceManager.getContainer('splashContainer').visible = false;
    resourceManager.getContainer('loadingContainer').visible = false;
    let luckyBetButton = resourceManager.get('buttonContainer:buttonBar:luckyBetToggleButton');

    if (gameData.recoverLuckyBetOn) {
      luckyBetButton.setRecovery();
    }

    const bgContainer = resourceManager.getContainer('backgroundContainer');
    bgContainer.visible = true;

    gameData.gameMask = new PIXI.Graphics();
    gameData.gameMask.beginFill(0xffffff);
    gameData.gameMask.lineStyle(0, 0xffffff);
    gameData.gameMask.drawRect(0, 0, 1, 1);
    bgContainer.addChild(gameData.gameMask);

    systemData.gameContainer.mask = gameData.gameMask;

    let license = gameData.license;
    if (license === '' || license === undefined) {
      license = 'default';
    } else {
      license = gameData.license.toUpperCase();
    }

    if (license === 'BR') {
      resourceManager.get('helpPageScroll').open();
    }

    gameData.winningsText = resourceManager.get('slotContainer:winningsText');

    helper.updateHelpWinlineText();

    // Initialise winline plugin
    winlineFadeAnimator.initialise();

    // Clear background interaction now we are starting game
    game.loadingBackgroundLandscape = resourceManager.get('splashBackgroundL');
    game.loadingBackgroundLandscape.clearInteractiveCallbacks();

    game.loadingBackgroundPortrait = resourceManager.get('splashBackgroundP');
    game.loadingBackgroundPortrait.clearInteractiveCallbacks();

    // resourceManager.get("loader").clearInteractiveCallbacks();
    // resourceManager.get("loader").visible = false;

    if (!Reflex.developerMode && gdk.deviceInfo.mobile && !gdk.isFullscreen()) {
      gdk.requestFullscreen();
    }

    if (gdk.deviceInfo.chrome && gdk.deviceInfo.android) {
      var chromeVersion = Number(
        String(gdk.deviceInfo.version).substring(0, String(gdk.deviceInfo.version).indexOf('.'))
      );
      if (chromeVersion >= 55) {
        // Chrome will only start audio on a touch
        Howler.ctx.resume();
      }
    }

    // Set up character either behind or in front of message bar
    gameData.gameContainer = resourceManager.getContainer('gameContainer');
    onResize();

    resourceManager.getContainer('loadingContainer').visible = false;
    resourceManager.getContainer('gameContainer').visible = true;
    resourceManager.getContainer('msgBoxPopupContainer').visible = true;
    resourceManager.getContainer('gameButtonContainer').visible = true;
    resourceManager.getContainer('particleContainer').visible = true;
    resourceManager.getContainer('buyABonusContainer').visible = true;
    resourceManager.getContainer('settingsMenuContainer').visible = true;
    resourceManager.getContainer('helpPageScrollContainer').visible = true;

    gameData.helpPageScroll = resourceManager.get('helpPageScroll');

    Reflex.registerEventHandler('devicePerformance', function (capability, gamePerformance) {
      resourceManager.devicePerformance = gamePerformance;
      setupPerformanceDependentObjects();
    });

    gameController.initialise();

    if (!freespins.inFreespins) {
      resourceManager.getController('inputOverlord').setState('enabled');
    }

    gameController.updateStake();
  }

  function enableEncore(enabled) {
    gameData.encoreEnabled = enabled;
  }

  function setupPerformanceDependentObjects() {
    // Performance meter has not yet been issued
    if (checkForUndefined(resourceManager.devicePerformance)) return;

    if (resourceManager.devicePerformance >= 80) {
      // High performance dependent objects go here (80-100)
    }

    if (resourceManager.devicePerformance >= 60) {
      // Medium performance dependent objects go here (60-100)
      //resourceManager.get("background").filters = [game.reflectionShader];
      /*timerManager.addTimer(3000,
				function(progress) {game.reflectionShader.uniforms.strength = progress * 0.3;},
				function() { game.reflectionShader.uniforms.strength = 0.3; } );
				*/
    }

    if (resourceManager.devicePerformance >= 40) {
      // Low performance dependent objects go here (40-100)
    }

    if (resourceManager.devicePerformance < 40) {
      // Minimum spec goes here (1 to 39)
    }
  }

  function blurGame(enable, value) {
    if (resourceManager.selectedAssetResolution.name === 'standard') {
      value = checkForDefined(value) ? value : 1;
      resourceManager.getContainer('gameContainer').filters = enable ? [new PIXI.filters.BlurFilter(value)] : [];
      resourceManager.getContainer('gameButtonContainer').filters = enable ? [new PIXI.filters.BlurFilter(value)] : [];
    }
  }

  function changeStake(selectedStake, bpl) {
    if (gameData.stakeMeter.value != selectedStake) {
      if (gameData.stakeMeter.value > 0) {
        soundManager.play('buttonPressed');
      }

      gameData.stakeMeter.set(selectedStake);
      gdk.playerChangedStake(selectedStake);
    }
  }

  function resetWinnings() {
    gameData.winningsMeter.set(0);
  }

  function creditChanged(creditTask) {
    gameData.credit = creditTask.data.balance;
    let credit = creditTask.data.balance;
    if (
      gdk.serverParser._inReplayMode === true &&
      gdk.serverParser._endGame === true &&
      gdk.serverParser.prepaidResultBalance !== 0 &&
      gdk.serverParser.prepaidResultBalance !== undefined
    ) {
      credit = gdk.serverParser.prepaidResultBalance;
    }
    gameData.creditMeter.set(credit);
  }

  function prepaidStakeChanged(stake) {
    gameData.stakeMeter.set(stake);
  }

  function promotionEnded() {
    const stakeController = resourceManager.getController('stakeController');
    const newStake = stakeController.getCurrentStake();
    gameData.stakeMeter.set(newStake);
  }

  function onLoaded(loader, res) {
    //var container = resourceManager.get("background");
    //var uniforms = { time:  {type:"f", value:0.0}, strength: {type:"f", value:0.0}, width: {type:"f", value:container.scale.x}, height: {type:"f", value:container.scale.y}, boundary: {type:"f", value:0.9} };
    //game.reflectionShader = new PIXI.Filter(null, res.shader.data, uniforms);
    setupPerformanceDependentObjects();
  }

  function onOrientationChange() {}

  function goToSplash() {
    resourceManager.getContainer('loadingbackgroundContainer').visible = false;
    resourceManager.getContainer('loadingbackgroundContainerPortrait').visible = false;
    let license = gameData.license;
    if (license === '' || license === undefined) {
      license = 'default';
    } else {
      license = gameData.license.toUpperCase();
    }
    if (gameData.currentSplash > gameData.numberOfSplashScreens || license === 'BR') {
      //UNCOMMENT TO ALLOW SPLASH SCREEN CHECK
      gdk.loadingClosed();
      Reflex.updateViewport();
    } else {
      showSplash(gameData.currentSplash);
      gameData.currentSplash++;
      if (!gdk.getPlatformAllowsUpstake()) {
        // If golden bet is not allowed then we increase currentSplash by 1 again so that it thinks we are already on the last splash screen and will skip it.
        gameData.currentSplash++;
      }
    }
  }

  function onResize() {
    if (gameData.gameMask) {
      if (systemData.isLandscape) {
        gameData.gameMask.scale.x = 1280;
        gameData.gameMask.scale.y = 720;
      } else {
        gameData.gameMask.scale.x = 720;
        gameData.gameMask.scale.y = 1280;
      }
    }

    if (checkForDefined(game.reflectionShader)) {
      game.reflectionShader.uniforms.width = Reflex.scaleX;
      game.reflectionShader.uniforms.height = Reflex.scaleY;
    }
  }

  function onReady() {
    var numSymbols = Object.keys(resourceManager.getConfiguration().symbols).length;

    // Set up symbol creation callbacks
    var slotMachine = GameSlotMachineFactory.getSlotMachine(0);
    for (var i = 0; i < numSymbols; ++i) {
      slotMachine.symbolCreationCallbacks[i.toString()] = helper.getSymbolChildrenDescriptions;
    }

    for (var i = 0; i < 5; i++) {
      slotMachine.reels[i].setAnySymbolCreatedCallback(helper.symbolCreationCallback);
    }
  }

  function update(delta) {
    if (checkForDefined(game.reflectionShader)) {
      game.reflectionShader.uniforms.time += delta / 1000;
    }
  }

  // define game object to be returned
  var game = {};

  Object.defineProperties(game, {
    enableEncore: {
      value: enableEncore,
    },
    onCloseTutorial: {
      value: onCloseTutorial,
    },
    showSplash: {
      value: showSplash,
    },
    initialise: {
      value: initialise,
    },
    blurGame: {
      value: blurGame,
    },
    changeStake: {
      value: changeStake,
    },
    resetWinnings: {
      value: resetWinnings,
    },
    dimAllSymbols: {
      value: dimAllSymbols,
    },

    goToSplash: {
      value: goToSplash,
    },
  });

  ///////////////////
  // subscriptions //
  ///////////////////

  messageBus.subscribe('common:BalanceEvent', creditChanged);
  messageBus.subscribe('prepaid:StakeChange', prepaidStakeChanged);
  messageBus.subscribe('common:PromotionEnded', promotionEnded);
  // messageBus.subscribe("stake:stakeChanged", changeStake);
  messageBus.subscribe('game:modal', onModal);
  Reflex.registerEventHandler('orientationChange', onOrientationChange);
  Reflex.registerEventHandler('ready', onReady);
  Reflex.registerEventHandler('resize', onResize);
  Reflex.addToUpdate(update);

  return game;
})();
